import React from 'react'
import { Flex, Label, Button, Table, InfoIcon, Span } from '@fareye/ui'
import { FaDownload, isEmpty, dMmm } from '@fareye/utils'
import { downloadToCSV, useTranslation } from '@fareye/common'

import { tripTabsBackground, modeBackground } from '@fareye/configs'
import { getTableColumns } from './Column'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px',
    height: 'fit-content'
  },
  downloadIcon: {
    marginLeft: '8px'
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: modeBackground,
    width: 'fit-content',
    marginBottom: '8px'
  }
}

export const OceanPortLogs = ({ otherData, config, data, type }: any) => {
  let oceanPortLogs = [];
  if (type === 'container') {
    oceanPortLogs = !isEmpty(otherData?.oceanPortLogs) ? otherData.oceanPortLogs : data?.oceanPortLogs || [];
  } else {
    oceanPortLogs = otherData?.oceanPortLogs || [];
  }
  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const { t } = useTranslation()
  const {
    config: { portLogColumns }
  } = config
  const selectedColumn = React.useMemo(() => {
    return getTableColumns(portLogColumns, {
      t,
      queryParams: {}
    })
  }, [])
  let translatedOceanPortLogs = oceanPortLogs
  translatedOceanPortLogs = translatedOceanPortLogs.map((item: any) => {
    return {
      ...item,
      code: t(item.code),
      eventRaw: t(item.eventRaw),
      locationTypeCode: t(item.locationTypeCode),
      locationTypeName: t(item.locationTypeName),
      alertEventType: t(item.alertEventType)
    }
  })
  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Flex justifyContentSpaceBetween>
          <Label
            style={{ fontSize: '16px', fontWeight: 600, marginTop: '6px' }}
          >
            {t('Ocean Port Logs')}
          </Label>
          <Flex>
            <Span
              style={{
                backgroundColor: 'rgba(0,157,50,0.15)',
                margin: '6px 4px',
                padding: '4px'
              }}
            >
              <InfoIcon title={``} style={{ marginRight: '4px' }} />
              {t('Local Time of the respective places is shown below')}
            </Span>

            <Button
              disabled={false}
              isLoading={false}
              variant="s primary"
              style={{ height: '30px' }}
              onClick={() => {
                setDownloadLoading(true)
                downloadToCSV({
                  data: translatedOceanPortLogs,
                  fileName: `portLogs_${dMmm()}`
                })
                setDownloadLoading(false)
              }}
            >
              {t('Download CSV')}
              <FaDownload style={style.downloadIcon} />
            </Button>
          </Flex>
        </Flex>
      </Flex>
      {console.log(123)}
      {!isEmpty(oceanPortLogs) ? (
        <Flex style={style.tripTabs} column>
          <Table
            className="striped responsive"
            totalElements={oceanPortLogs.length}
            sortable={false}
            showTotalCount={false}
            showPagination={false}
            data={oceanPortLogs}
            columns={selectedColumn}
          />
        </Flex>
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('No Data')}
        </Label>
      )}
    </Flex>
  )
}
